import { useState } from 'react';
import { techIcons } from '../data/techIcons';

export default function TechBadge({ name }) {
  const iconUrl = techIcons[name];
  const [imgFailed, setImgFailed] = useState(false);
  const showIcon = iconUrl && !imgFailed;

  if (showIcon) {
    return (
      <li className="tech-badge tech-badge--icon" title={name}>
        <img
          src={iconUrl}
          alt=""
          className="tech-badge__icon"
          width={20}
          height={20}
          onError={() => setImgFailed(true)}
        />
      </li>
    );
  }

  return (
    <li className="tech-badge tech-badge--fallback" title={name}>
      <span aria-hidden="true">{name.charAt(0)}</span>
    </li>
  );
}
